import { createRouter, createWebHistory } from "vue-router";
export const loginRoutes = [];

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: `/nav`,
      name: "main",
      component: () => import("@/page/main/main.vue"),
      children: [
        {
          // Overview
          path: `/`,
          name: "overview",
          component: () => import("@/page/home/overview.vue"),
          meta: { title: "overview" },
        },
        {
          // Api keys
          path: `/apiKeys`,
          name: "apiKeys",
          component: () => import("@/page/apiKey/apiKeys.vue"),
          meta: { title: "apiKeys" },
        },
        {
          // pricing
          path: `/pricing`,
          name: "pricing",
          component: () => import("@/page/price/pricing.vue"),
          meta: {
            title: "pricing",
          },
        },
        {
          // documentation
          path: `/documentation`,
          name: "documentation",
          component: () => import("@/page/home/overview.vue"),
          meta: {
            title: "documentation",
          },
        },
        {
          // billing
          path: `/billing`,
          name: "billing",
          component: () => import("@/page/billing/billing.vue"),
          meta: {
            title: "billing",
          },
        },
        {
          // terms
          path: `/terms`,
          name: "terms",
          component: () => import("@/page/home/overview.vue"),
          meta: {
            title: "terms",
          },
        },
        {
          path: `/payment-cn-result`,
          name: "pay-result",
          component: () => import("@/page/pay/result.vue"),
          meta: {
            title: "result",
          },
        },
      ],
    },
    {
      path: `/recoveraccount`,
      name: "recover",
      component: () => import("@/page/recover/recover.vue"),
    },
    {
      path: "/:pathMatch(.*)*", // 匹配所有未定义的路径
      name: "NotFound",
      component: () => import("@/page/notfound.vue"),
    },
  ],
});

// 在应用的状态中跟踪导航历史
export let navigationHistory = [];

// 监听路由变化
router.beforeEach((to, from, next) => {
  to.meta.from = from.fullPath;
  // 更新导航历史
  // 加入路由守卫，如果是mureka直接跳转到新版本的详情页
  next();
});

export default router;
